import { Pipe, PipeTransform } from '@angular/core';

import { ClienteItemTipo } from '../cliente-item-tipo';
import { ItemTipo } from '../../../../item-tipo';

@Pipe({
    name: 'clienteItemTipoMap',
    pure: false
})
export class ClienteItemTipoMapPipe implements PipeTransform {
    /** Retorna os tipos de itens dos clientes */
    transform(entities: ClienteItemTipo[]): ItemTipo[] {
        if (!entities) {
            return [];
        }

        // Filtra somente os que possuirem o tipo de item e faz um map para retornar os objetos do tipo ItemTipo
        return entities.filter(entityFilter => entityFilter.idItemTipo && entityFilter.itemTipo).map<ItemTipo>(entity => entity.itemTipo);
    }
}
